export const GRID_BREAKPOINT_XS = 0
export const GRID_BREAKPOINT_SM = 600
export const GRID_BREAKPOINT_MD = 1000
export const GRID_BREAKPOINT_LG = 1200
export const GRID_BREAKPOINT_XL = 1904
